import request from "_private/utils/request";


// 获取字典类型下拉框
export function FetchDictionaryType() {
    return request({
        url: "/base/dictionary/findDictionaryType",
        method: "get"
    });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/dictionary/findByPage",
        method: "post",
        data
    });
}

/**
 * 新增、修改字典数据
 * @param {*} data
 */
export function FetchSave(data) {
    return request({
        url: "/base/dictionary/saveDictionary",
        method: "post",
        data
    });
}

/**
 * 修改时，先获取信息
 * @param {*} data
 */
export function FetchFindById(data) {
    return request({
        url: "/base/dictionary/findById",
        method: "post",
        data
    });
}

/**
 * 删除字典数据
 * @param {*} data
 */
export function FetchDelete(data) {
    return request({
        url: "/base/dictionary/deleteDictionary",
        method: "post",
        data
    });
}
